import { api } from './api'
import { sectionBasePathForRole, type AuthUser } from './auth'
import type { Notification } from '@riverpark/types'

export async function listNotifications(
  unreadOnly = false,
): Promise<{ data: Notification[]; meta: { unreadCount: number } }> {
  return api.get<{ data: Notification[]; meta: { unreadCount: number } }>(
    `/notifications${unreadOnly ? '?unreadOnly=true' : ''}`,
  )
}

export async function markAllNotificationsRead(): Promise<{ data: { success: boolean } }> {
  return api.post<{ data: { success: boolean } }>('/notifications/read-all', {})
}

export async function markNotificationRead(id: string): Promise<{ data: { success: boolean } }> {
  return api.patch<{ data: { success: boolean } }>(`/notifications/${id}/read`, {})
}

/** Where clicking a notification (bell dropdown, Activity tab) should take the viewer — routes
 * under the viewer's own section, since admin/committee/estate_manager each live under their own
 * `/admin`, `/committee`, `/operations` prefix rather than the member portal's bare paths. */
export function notificationHref(item: Notification, role: AuthUser['role']): string | null {
  const basePath = sectionBasePathForRole(role)
  switch (item.entityType) {
    case 'announcement':
      return `${basePath}/announcements/${item.entityId}`
    case 'service_request':
      return `${basePath}/requests?open=${item.entityId}`
    case 'invoice':
      return `/bills/${item.entityId}`
    case 'approval':
      // Same route name under every role's section — committee/admin land on the approval
      // queue, estate_manager lands on their own "My requests" history.
      return `${basePath}/approvals`
    case 'document_request':
      return `${basePath}/documents?tab=requests`
    default:
      return null
  }
}
